export default "/assets/Image/maintenance-page-bg-bw.jpg"